<script setup lang="ts">
type Prop = {
  item: Article
  isDate: boolean
}

const props = withDefaults(defineProps<Prop>(), {})

const app = useNuxtApp()
const dayjs = useDayjs()

const bodyText = () => {
  let s = null
  if (props.item.body_json) {
    s = app.$getBody(props.item.body_json)
    if (s) {
      s = s.replace(/\[url=(.+?)\](.+?)\[\/url\]/g, '<a href="$1" class="c-newsFrom">$2</a>')
    }
  }
  return s
}

const getDate = (val) => {
  const dj = useDayjs(val)
  if (dj.isValid()) {
    return dj.format('M/D')
  }
  return ''
}
</script>

<template>
  <div
    class="c-naruhodoItem"
    v-bind:class="{ 'is-date': isDate }"
  >
    <div class="c-naruhodoItem_date">
      <template
        v-if="isDate"
      >
        {{ getDate(item.open_date) }}
      </template>
    </div>
    <div class="c-naruhodoItem_data">
      <div
        class="c-naruhodoItem_data_eventUpper"
      >
        <div class="c-naruhodoItem_data_eventUpper_title">
          {{ item.title }}
        </div>
        <div
          v-if="item.term_from"
          class="c-naruhodoItem_data_eventUpper_time"
        >
          (掲載日時:{{ dayjs(item.term_from).format('YYYY年M月D日') }})
        </div>
        <div
          class="c-naruhodoItem_data_eventUpper_content"
          v-html="bodyText()"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.c-naruhodoItem {
  display: flex;
  width: 100%;

  @include responsive.mq_down(sp) {
    display: block;
  }

  &_date {
    flex: 0 0 115px;
    flex-direction: column;
    overflow: hidden;
    color: var(--color_primary);
    font-family: var(--g_font_family_NanumGothic);
    font-size: 36px;
    font-weight: bold;
    line-height: 1;

    @include responsive.mq_down(sp) {
      font-size: 26px;
    }
  }

  &_data {
    flex-direction: column;
    padding-top: 20px;
    border-top: 1px solid var(--g_color_border_gray);
    color: var(--color_text_base);
    font-family: var(--g_font_family_NotoSansCJKjp);

    &_eventUpper {
      flex-direction: column;

      &_title {
        font-size: 20px;
        font-weight: bold;
        line-height: 1.5;

        @include responsive.mq_down(sp) {
          font-size: 18px;
        }
      }

      &_time {
        margin-top: 9px;
        font-size: 14px;

        @include responsive.mq_down(sp) {
          font-size: var(--g_fontSize_small_sp);
        }
      }

      &_content {
        margin-top: 5px;
        font-size: 16px;

        @include responsive.mq_down(sp) {
          font-size: var(--g_fontSize_middle_sp);
        }
      }
    }

    &_divider {
      margin-top: 20px;

      @include responsive.mq_down(sp) {
        border-style: dashed;
      }
    }

    &_eventLower {
      flex-direction: column;

      &_title {
        margin-top: 19px;
        font-size: 20px;
        font-weight: bold;
      }

      &_time {
        margin-top: 8px;
        font-size: 14px;
      }

      &_openingTime {
        margin-top: 6px;
        margin-bottom: 3px;
        color: var(--color_primary);
        font-size: 16px;
      }
    }
  }

  &.is-date {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid var(--g_color_border_gray);
  }

  &.is-date & {
    &_data {
      padding-top: 5px;
      border-top: none;
    }
  }

  &:first-child {
    padding-top: 0;
    border-top: none;
  }

  &:last-child {
    padding-bottom: 30px;
    border-bottom: 1px solid #ebebeb;
  }
}
</style>
